export default {
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
  },
  toggle: {
    marginLeft: 6,
  },
  content: {
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loading: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrap: {
    flexWrap: 'wrap',
  },
  actionHeader: {
    display: 'flex', flexDirection: 'row', alignItems: 'center',
  },
  checkbox: {
    width: 240
  },
  select: {
    marginLeft: 12, marginRight: 8, marginTop: 12, width: 100
  }
};



// WEBPACK FOOTER //
// ./src/styles/EmployeeHoliday.js